import { render, staticRenderFns } from "./_form-request.vue?vue&type=template&id=74a67403&scoped=true"
import script from "./_form-request.vue?vue&type=script&lang=js"
export * from "./_form-request.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a67403",
  null
  
)

export default component.exports